import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SlidersHorizontal, Search } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { api } from "@/lib/api";
import ProductCard from "@/components/store/ProductCard";

export default function Products() {
  const { t, pick } = useI18n();
  const [sp, setSp] = useSearchParams();
  const [data, setData] = useState(null);
  const [cats, setCats] = useState([]);
  const [show, setShow] = useState(false);
  const [q, setQ] = useState(sp.get("q") || "");
  const set = (k, v) => { const n = new URLSearchParams(sp); v ? n.set(k, v) : n.delete(k); n.delete("page"); setSp(n); };
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);
  useEffect(() => {
    const p = { q: sp.get("q") || undefined, category: sp.get("category") || undefined, sort: sp.get("sort") || "new",
      in_stock: sp.get("in_stock") === "1" || undefined, offer: sp.get("offer") === "1" || undefined,
      min_price: sp.get("min") ? Math.round(sp.get("min") * 100) : undefined, max_price: sp.get("max") ? Math.round(sp.get("max") * 100) : undefined };
    setData(null);
    api.get("/products", { params: p }).then((r) => setData(r.data));
  }, [sp]);
  const filters = (
    <div className="space-y-6">
      <div><p className="label">{t("filters.category")}</p>
        <select data-testid="filter-category" className="input" value={sp.get("category") || ""} onChange={(e) => set("category", e.target.value)}>
          <option value="">{t("filters.all")}</option>{cats.map((c) => <option key={c.category_id} value={c.category_id}>{pick(c.name)}</option>)}
        </select></div>
      <div><p className="label">{t("filters.price")}</p>
        <div className="flex gap-2">
          <input data-testid="filter-min-price" type="number" inputMode="numeric" className="input" placeholder={t("filters.min")} defaultValue={sp.get("min") || ""} onBlur={(e) => set("min", e.target.value)} />
          <input data-testid="filter-max-price" type="number" inputMode="numeric" className="input" placeholder={t("filters.max")} defaultValue={sp.get("max") || ""} onBlur={(e) => set("max", e.target.value)} />
        </div></div>
      <label className="flex items-center gap-3 text-sm cursor-pointer"><input data-testid="filter-in-stock" type="checkbox" className="w-5 h-5 accent-[#2563EB]" checked={sp.get("in_stock") === "1"} onChange={(e) => set("in_stock", e.target.checked ? "1" : "")} />{t("filters.in_stock")}</label>
      <label className="flex items-center gap-3 text-sm cursor-pointer"><input data-testid="filter-offers" type="checkbox" className="w-5 h-5 accent-[#2563EB]" checked={sp.get("offer") === "1"} onChange={(e) => set("offer", e.target.checked ? "1" : "")} />{t("filters.offers")}</label>
    </div>
  );
  return (
    <div className="container-x py-8 sm:py-12" data-testid="products-page">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6">{sp.get("q") ? t("products.results_for", { q: sp.get("q") }) : t("products.title")}</h1>
      <form onSubmit={(e) => { e.preventDefault(); set("q", q); }} className="relative mb-6 md:hidden">
        <Search className="w-4 h-4 absolute top-1/2 -translate-y-1/2 start-4 text-[#6B7280]" />
        <input data-testid="products-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("nav.search_placeholder")} className="input ps-10 rounded-full" />
      </form>
      <div className="flex items-center gap-3 mb-6">
        <button data-testid="toggle-filters-btn" onClick={() => setShow(!show)} className="btn-ghost h-10 lg:hidden"><SlidersHorizontal className="w-4 h-4" />{t("filters.title")}</button>
        <span className="text-sm muted">{data ? t("products.count", { n: data.total }) : ""}</span>
        <select data-testid="sort-select" className="input h-10 w-auto ms-auto rounded-full" value={sp.get("sort") || "new"} onChange={(e) => set("sort", e.target.value)}>
          {["new", "best", "price_asc", "price_desc"].map((s) => <option key={s} value={s}>{t(`sort.${s}`)}</option>)}
        </select>
      </div>
      <div className="grid lg:grid-cols-[240px_1fr] gap-8">
        <aside className={`${show ? "block" : "hidden"} lg:block card p-5 h-fit`}>{filters}</aside>
        <div>
          {!data ? <div className="grid grid-cols-2 md:grid-cols-3 gap-4">{Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[3/4] rounded-2xl bg-[#E5E7EB] animate-pulse" />)}</div>
            : data.items.length === 0 ? <div data-testid="products-empty" className="card p-12 text-center muted">{t("products.empty")}</div>
              : <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-6">{data.items.map((p, i) => <ProductCard key={p.product_id} p={p} i={i} />)}</div>}
        </div>
      </div>
    </div>
  );
}
